export default (block: any) => {
  block = JSON.parse(JSON.stringify(block));
  switch (block.tagName) {
    case "mj-text":
      return {
        content: block.content,
      };
    case "mj-button":
      return {
        content: block.content,
        attributes: {
          href: block.attributes.href,
        },
      };
    case "mj-image":
      return {
        attributes: {
          src: block.attributes.src,
          alt: block.attributes.alt,
          title: block.attributes.title,
          href: block.attributes.href,
        },
      };
    case "mj-gif":
      return {
        attributes: {
          src: block.attributes.src,
          alt: block.attributes.alt,
          href: block.attributes.href,
        },
      };
    case "mj-raw":
      return {
        content: block.content,
      };
    case "mj-social":
      return {
        children: block.children?.map((child: any) => ({
          attributes: {
            href: child.attributes.href,
            alt: child.attributes.alt,
          },
        })),
      };
    case "mj-social-element":
      return {
        attributes: {
          href: block.attributes.href,
          alt: block.attributes.alt,
        },
      };
    case "mj-rating":
      return {
        questionText: block.questionText,
        captionTextLeft: block.captionTextLeft,
        captionTextRight: block.captionTextRight,
        urlPattern: block.urlPattern,
        children: block.children?.map((child: any) => ({
          attributes: {
            label: child.attributes.label,
            alt: child.attributes.alt,
            href: child.attributes.href,
            src: child.attributes.src,
            value: child.attributes.value,
          },
        })),
      };
    case "mj-rating-segment":
      return {
        attributes: {
          label: block.attributes.label,
          href: block.attributes.href,
          alt: block.attributes.alt,
          src: block.attributes.src,
          value: block.attributes.value,
        },
      };
    case "mj-feed-block":
      // Items are translatable per-id; the primary translation holds the
      // authoritative full items. Non-primary translations carry sparse
      // overrides matched by item.id.
      return {
        items: Array.isArray(block.items) ? block.items.map((i: any) => ({ ...i })) : [],
      };
    default:
      return {};
  }
};
